export const updateOutboundShipmentMini = /* GraphQL */ `
  mutation UpdateOutboundShipment(
    $input: UpdateOutboundShipmentInput!
    $condition: ModelOutboundShipmentConditionInput
  ) {
    updateOutboundShipment(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateOutboundShipment = /* GraphQL */ `
  mutation UpdateOutboundShipment(
    $input: UpdateOutboundShipmentInput!
    $condition: ModelOutboundShipmentConditionInput
  ) {
    updateOutboundShipment(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      state
      transfer
      transferToAccountId
      transferToAccountName
      poNumber
      consigneePoNumber
      pickupNumber
      shipTo {
        name
        street
        city
        state
        zipCode
        country
      }
      checklist {
        id
        name
        description
        stepName
        isRequired
        isCompleted
        completedBy
        completedAt
      }
      carrierType
      carrierName
      bolNumber
      railCarNumber
      mustTarp
      seals {
        items {
          id
          active
          owner
          groups
          reloadYardId
          accountId
          accountName
          referenceId
          referenceName
          barcode
          isScanned
          createdAt
          createdBy
          validated
          reValidated
          brokenAt
          brokenBy
          description
          status
          updatedAt
        }
        nextToken
      }
      skipSignature
      yardSignatureKey
      carrierSignatureKey
      createDateTime
      scheduledDateTime
      arrivalDateTime
      placementDateTime
      startDateTime
      endDateTime
      departureDateTime
      tareWeight
      ladenWeight
      netWeight
      weightUnits
      totalUOM
      areaId
      area {
        id
        active
        reloadYardId
        name
        prefix
        areaType
        color
        sortKey
      }
      attachments {
        bucket
        region
        key
        type
        createdBy
        createdAt
      }
      bolFile {
        bucket
        region
        key
      }
      sealNumber
      assignedTo
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      accountName
      accountId
      account {
        id
        owner
        groups
        active
        status
        lotNumberPrefix
        businessName
        email
        phone
        fax
        website
        address {
          name
          street
          city
          state
          zipCode
          country
        }
        reloadYardId
        trackInboundSeals
        trackOutboundSeals
        outboundCustomFields {
          id
          name
          type
          display
        }
        outboundPhotos
        inventoryCustomFields {
          id
          name
          type
          display
        }
        bolTemplate {
          key
          type
        }
      }
      reloadYardId
      shipmentLineItems {
        items {
          id
          owner
          groups
          active
          status
          lotNumber
          totalQuantityToPick
          outboundShipmentId
          reloadYardId
          inventoryId
          inventoryItems {
            items {
              id
              status
              outboundShipmentId
              shipmentLineItemId
              inventoryItemId
              inventoryItem {
                id
                quantityOnHand
                quantityCommitted
                hasException
                isDamaged
                originOfDamage
                otherException
                otherExceptionNote
                status
                inventoryId
                inventory {
                  id
                  owner
                  groups
                  active
                  status
                  lotNumber
                  poNumber
                  railCarNumber
                  receivedAt
                  depletedAt
                  turnDays
                  quantityAdvised
                  quantityReceived
                  quantityOnHand
                  quantityPhysical
                  quantityCommitted
                  quantityMismatch
                  inventoryUOM
                  weight
                  weightUOM
                  verificationRequired
                  hasException
                  overShipment
                  overShipmentQuantity
                  overShipmentNote
                  underShipment
                  underShipmentQuantity
                  underShipmentNote
                  isDamaged
                  isRecalled
                  recallNote
                  otherException
                  otherExceptionNote
                  lotType
                  aisleList
                  outboundShipmentId
                  productName
                  productCode
                  productId
                  sortKey
                  accountName
                  accountId
                  reloadYardId
                  inboundShipmentId
                  auditId
                  reloadYardCommodityId
                  customFields
                }
                location {
                  id
                  owner
                  groups
                  active
                  reloadYardId
                  name
                  type
                  capacityUsed
                  capacityAllocated
                  locationLoad {
                    other {
                      selected
                      capacity
                    }
                    pallet {
                      selected
                      capacity
                    }
                    box {
                      selected
                      capacity
                    }
                    container {
                      selected
                      capacity
                    }
                    superSack {
                      selected
                      capacity
                    }
                    dryBulk {
                      selected
                      capacity
                    }
                    liquidBulk {
                      selected
                      capacity
                    }
                  }
                  areaId
                  area {
                    id
                    active
                    reloadYardId
                    name
                    prefix
                    areaType
                    sortKey
                  }
                  zoneId
                  zone {
                    id
                    active
                    reloadYardId
                    name
                    prefix
                    accountId
                    areaId
                    sortKey
                  }
                  aisleId
                  aisle {
                    id
                    name
                    type
                    areaId
                    zoneId
                    bays
                    levels
                    capacityUsed
                    length
                    width
                    sortKey
                    topDownPickOrder
                  }
                  bay
                  level
                  position
                  length
                  width
                  sortKey
                }
                outboundShipmentId
                locationFullName
                reloadYardId
              }
              quantityToPick
            }
            nextToken
          }
          inventory {
            id
            active
            groups
            reloadYardId
            status
            productName
            productCode
            productId
            reloadYardCommodityId
            reloadYardCommodity {
              id
              reloadYardId
              commodityId
              units
              sortKey
              commodity {
                id
                name
                defaultUnits
              }
            }
            product {
              id
              category
              name
              productCode
              defaultUOM
              defaultWeightUOM
              unit
              pcs
              mbf
              lf
              msf
              sqm
              gal
              l
              lbs
              tn
              cwt
              kg
              mt
              ft
              m
              width
              length
              height
              lowInventoryThreshold
              totalInventoryQuantity
              totalQuantityOnHand
              totalQuantityCommitted
              lowInventoryAlert
            }
            accountName
            accountId
            lotType
            lotNumber
            poNumber
            areaId
            zoneId
            # photos {
            #   bucket
            #   region
            #   key
            # }
            depletedAt
            quantityOnHand
            quantityAdvised
            quantityCommitted
            quantityPhysical
            inventoryUOM
            weight
            weightUOM
            notes {
              type
              date
              by
              text
              public
            }
            history {
              type
              date
              by
              text
            }
            customFields
          }
          notes {
            type
            date
            by
            text
            public
          }
          history {
            type
            date
            by
            text
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      reloadYardCommodityId
      reloadYardCommodity {
        id
        reloadYardId
        commodityId
        units
        sortKey
        commodity {
          id
          name
          defaultUnits
        }
      }
      invoiceId
      customFields
      selectedCustomFields {
        id
        name
        type
        display
      }
      createdAt
      updatedAt
    }
  }
`;

export const updateShipmentLineItemMini = /* GraphQL */ `
  mutation UpdateShipmentLineItem(
    $input: UpdateShipmentLineItemInput!
    $condition: ModelShipmentLineItemConditionInput
  ) {
    updateShipmentLineItem(input: $input, condition: $condition) {
      id
    }
  }
`;

export const updateShipmentLineItem = /* GraphQL */ `
  mutation UpdateShipmentLineItem(
    $input: UpdateShipmentLineItemInput!
    $condition: ModelShipmentLineItemConditionInput
  ) {
    updateShipmentLineItem(input: $input, condition: $condition) {
      id
      owner
      groups
      active
      status
      sortKey
      lotNumber
      totalQuantityToPick
      notes {
        type
        date
        by
        text
        public
      }
      history {
        type
        date
        by
        text
      }
      # pickupPhoto {
      #   bucket
      #   region
      #   key
      #   type
      #   createdBy
      #   createdAt
      # }
      outboundShipmentId
      accountId
      reloadYardId
      inventoryId
      inventory {
        id
        owner
        groups
        active
        status
        lotNumber
        poNumber
        receivedAt
        depletedAt
        turnDays
        quantityAdvised
        quantityReceived
        quantityOnHand
        quantityPhysical
        quantityCommitted
        quantityMismatch
        inventoryUOM
        weight
        weightUOM
        verificationRequired
        lotType
        areaId
        zoneId
        notes {
          type
          date
          by
          text
          public
        }
        history {
          type
          date
          by
          text
        }
        productName
        productCode
        productId
        product {
          id
          owner
          groups
          active
          accountId
          reloadYardId
          name
          productCode
          reloadYardCommodityId
          category
          defaultUOM
          defaultWeightUOM
          unit
          pcs
          mbf
          lf
          msf
          sqm
          gal
          l
          lbs
          tn
          cwt
          kg
          mt
          ft
          m
          width
          length
          height
          lowInventoryThreshold
          totalInventoryQuantity
          totalQuantityOnHand
          totalQuantityCommitted
          lowInventoryAlert
          customFields
          createdAt
          updatedAt
        }
        sortKey
        accountName
        accountId
        account {
          id
          # owner
          groups
          active
          status
          externalId
          lotNumberPrefix
          businessName
          defaultWeightUOM
          email
          phone
          # fax
          # website
          billingEmail
          addressState
          reloadYardId
          inboundInstructions
          podEmail
          outboundInstructions
          posEmail
          outboundSkipSignature
          secondaryReview
          # createdAt
          # updatedAt
        }
        reloadYardId
        inboundShipmentId
        inboundShipment {
          id
          owner
          groups
          active
          status
          state
          poNumber
          lotNumber
          lotNumberOverride
          shipFrom
          carrierType
          carrierName
          lotType
          railCarNumber
          totalUOM
          tareWeight
          ladenWeight
          weightUnits
          netWeight
          scaleWeightUnits
          createDateTime
          scheduledDateTime
          notifyDateTime
          placedDateTime
          startDateTime
          endDateTime
          releaseDateTime
          collectedDateTime
          stripeBillingDateTime
          daysOnDemurrageClock
          assignedTo
          workflowType
          unloadedBy
          reviewedBy
          secondaryReview
          verificationRequired
          instructions
          accountName
          accountId
          reloadYardId
          invoiceId
          areaId
          zoneId
          isCollected
          reloadYardCommodityId
          customFields
          createdAt
          updatedAt
        }
        shipmentLineItems {
          nextToken
        }
        auditId
        reloadYardCommodityId
        reloadYardCommodity {
          id
          reloadYardId
          commodityId
          owner
          groups
          active
          verified
          units
          sortKey
          createdAt
          updatedAt
        }
        customFields
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;

export const updateShipmentLineItemInventoryItem = /* GraphQL */ `
  mutation UpdateShipmentLineItemInventoryItem(
    $input: UpdateShipmentLineItemInventoryItemInput!
    $condition: ModelShipmentLineItemInventoryItemConditionInput
  ) {
    updateShipmentLineItemInventoryItem(input: $input, condition: $condition) {
      id
      owner
      groups
      reloadYardId
      outboundShipmentId
      shipmentLineItemId
      inventoryId
      inventoryItemId
      hasException
      barcodeException
      barcodeExceptionNote
      otherException
      otherExceptionNote
      inventoryItem {
        id
        owner
        groups
        quantityOnHand
        quantityCommitted
        status
        inventoryId
        inventory {
          id
          owner
          groups
          active
          status
          lotNumber
          poNumber
          railCarNumber
          receivedAt
          depletedAt
          turnDays
          quantityAdvised
          quantityReceived
          quantityOnHand
          quantityPhysical
          quantityCommitted
          quantityMismatch
          inventoryUOM
          weight
          weightUOM
          verificationRequired
          hasException
          overShipment
          overShipmentQuantity
          overShipmentNote
          underShipment
          underShipmentQuantity
          underShipmentNote
          isDamaged
          isRecalled
          recallNote
          otherException
          otherExceptionNote
          lotType
          areaId
          zoneId
          aisleList
          productName
          productCode
          productId
          sortKey
          accountName
          accountId
          reloadYardId
          inboundShipmentId
          auditId
          reloadYardCommodityId
          customFields
          createdAt
          updatedAt
        }
        areaId
        area {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          color
          areaType
          sortKey
          createdAt
          updatedAt
        }
        zoneId
        zone {
          id
          owner
          groups
          active
          reloadYardId
          name
          prefix
          accountId
          areaId
          color
          zoneType
          sortKey
          createdAt
          updatedAt
        }
        aisleId
        locationId
        location {
          id
          owner
          groups
          active
          reloadYardId
          productId
          name
          type
          areaId
          area {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            color
            areaType
            sortKey
          }
          zoneId
          zone {
            id
            owner
            groups
            active
            reloadYardId
            name
            prefix
            accountId
            areaId
            color
            zoneType
            sortKey
          }
          aisleId
          aisle {
            id
            owner
            groups
            active
            reloadYardId
            name
            type
            areaId
            zoneId
            bays
            levels
            capacityUsed
            topDownPickOrder
            length
            width
            sortKey
          }
          bay
          level
          position
          capacityUsed
          capacityAllocated
          length
          width
          sortKey
          locationLoad {
            other {
              selected
              capacity
            }
            pallet {
              selected
              capacity
            }
            box {
              selected
              capacity
            }
            container {
              selected
              capacity
            }
            superSack {
              selected
              capacity
            }
            dryBulk {
              selected
              capacity
            }
            liquidBulk {
              selected
              capacity
            }
          }
          tags {
            nextToken
          }
        }
        outboundShipmentId
        reloadYardId
        createdAt
        updatedAt
      }
      quantityToPick
      status
      createdAt
      updatedAt
    }
  }
`;
